import React, { useMemo } from 'react';

const useDataTableStyles = (sx = {}) => {
    const data = useMemo(() => ({
        display: "grid block",
        gridTemplateRows: "auto 1fr auto",
        "& .MuiTablePagination-selectLabel, & .MuiTablePagination-displayedRows": {
            marginBottom: 0,
        },
        "& .MuiDataGrid-main": {
            backgroundColor: "#fff",
        },
        "&.MuiDataGrid-root--densityCompact .MuiDataGrid-cell": { py: "2px" },
        "&.MuiDataGrid-root--densityStandard .MuiDataGrid-cell": {
            py: "8px",
        },
        "&.MuiDataGrid-root--densityComfortable .MuiDataGrid-cell": {
            py: "15px",
        },
        "& .MuiMenu-list li": {
            width: "100%",
            justifyContent: "center",
        },
        "& .MuiDataGrid-columnHeaderTitle": {
            whiteSpace: "normal",
            lineHeight: "normal",
            py: "15px",
        },
        "& .MuiDataGrid-columnHeader": {
            // Forced to use important since overriding inline styles
            height: "unset !important",
            py: "15px",
        },
        "& .MuiDataGrid-columnHeaders": {
            maxHeight: "80px !important",
        },
        ...sx,
    }), [sx]);
    return data;
}

export default useDataTableStyles;
